import styled from "styled-components";
import { ExplanationData } from "../../../Data/ExplanationData";

const Box = styled.div`
  width: 328px;
  min-height: 80px;
  margin: 10px 0;
  padding: 10px;
  background-color: rgba(147, 112, 219, 0.3);
  font-size: 12px;
  text-align: left;
  display: flex;
  flex-direction: column;
`;

const Text = styled.p`
  display: flex;
  gap: 10px;
  margin-bottom: ${(props) => props.mb || 0}px;
`;

const Explanation = ({ page }) => {
  const data = ExplanationData.find((elem) => elem.page === page);
  return (
    <>
      {data ? (
        <>
          {data.list.map((elem) => (
            <Box>
              {elem.map((obj) =>
                obj.type === "title" ? (
                  <Text key={obj.id} mb={10}>
                    <span>ⓘ</span>
                    {obj.text}
                  </Text>
                ) : (
                  <Text key={obj.id}>
                    <span>·</span>
                    {obj.text}
                  </Text>
                )
              )}
            </Box>
          ))}
        </>
      ) : null}
    </>
  );
};

export default Explanation;
